import { ref } from "yup";
import Auth from "./auth";
import { clioTokenManager } from "./clio";
import { fieldsparameters } from "./fields";

/* eslint-disable prettier/prettier */
const clientId = "FmL7KXYF0NtbOWnFFZACrqSUJ66yEm3IiZPgSSut";
const redirect_uri = "https://www.celgreports.net/dashboard";
const clioURL = "https://app.clio.com/oauth/authorize";
const clioState = "retrieved";

const apiurl = "https://lvg24haprg.execute-api.us-east-1.amazonaws.com/prod";

export async function getToken(code) {
    const token = await new Auth().getToken();


    const response = await fetch(`${apiurl}/clio/token?code=${code}`, {
        method: "GET",
        headers: {
            Authorization: token,
        },
    });
    return response.json().then((response) => {
        if (response.body?.errorMessage) {
            throw Error(response.body.errorMessage);
        }
        return response;
    });
}

export async function refreshToken() {
    const token = await new Auth().getToken();
    const response = await fetch(`${apiurl}/clio/refresh-token`, {
        method: "GET",
        headers: {
            Authorization: token,
        },
    });
    return response.json().then((response) => {
        if (response.body?.errorMessage) {
            throw Error(response.body.errorMessage);
        } else {
            const parsed = JSON.parse(response.body);
            const clio_token = parsed.response.access_token;
            clioTokenManager.setToken(clio_token, undefined);
        }
        return response;
    });
}

export const askClio = () => {
    window.location = `${clioURL}?response_type=code&client_id=${clientId}&redirect_uri=${redirect_uri}&state=${clioState}`;
};

const FUNCTION_URL_ENDPOINTS = {
    bills: "https://ugz7wqgcd2wnlbaov653bzwh2y0lukio.lambda-url.us-east-1.on.aws/",
    activities: "https://neothf62y2wgk2c3ptgllzapri0nvftm.lambda-url.us-east-1.on.aws/",
};

export const getClioData = async (
    issued_after,
    issued_before,
    endpoint,
    retryCount = 0
) => {
    if (retryCount >= 3) {
        throw new Error(`getClioData failed after ${retryCount} retries for endpoint: ${endpoint}`);
    }

    try {
        const fields = fieldsparameters[endpoint].replace(/(\r\n|\n|\r)/gm, "");
        const clio_token = clioTokenManager.getToken();

        const status = "open,pending,closed";
        const state = "draft, awaiting_approval, awaiting_payment, paid";

        const isFunctionUrl = Object.prototype.hasOwnProperty.call(FUNCTION_URL_ENDPOINTS, endpoint);
        const base = isFunctionUrl
            ? FUNCTION_URL_ENDPOINTS[endpoint]
            : `${apiurl}/clio/data/${endpoint}`;

        const url = `${base}?token=${clio_token}&fields=${fields}&issued_after=${issued_after}&issued_before=${issued_before}&state=${state}&status=${status}&order=id(asc)`;
        const encoded = encodeURI(url);

        const idToken = await new Auth().getToken();
        const accessToken = await new Auth().getAccessToken();

        const response = await fetch(encoded, {
            method: "GET",
            headers: {
                Authorization: isFunctionUrl ? `Bearer ${accessToken}` : idToken,
            },
        });

        if (isFunctionUrl) {
            if (!response.ok) {
                console.error(`${endpoint} fetch failed: ${response.status}`, await response.text());
                await refreshToken();
                return await getClioData(issued_after, issued_before, endpoint, retryCount + 1);
            }
            return await response.json();
        }

        return response.json().then(async (parsed) => {
            if (parsed.statusCode !== 200) {
                await refreshToken();
                return await getClioData(issued_after, issued_before, endpoint, retryCount + 1);
            }
            return parsed;
        });
    } catch (e) {
        console.error(`getClioData error (attempt ${retryCount + 1}):`, e);
        await refreshToken();
        return await getClioData(issued_after, issued_before, endpoint, retryCount + 1);
    }
};

export const getPersistedData = async (endpoint) => {
    const url = `${apiurl}/dynamodb/${endpoint}`;


    const encoded = encodeURI(url);
    const token = await new Auth().getToken();

    const response = await fetch(encoded, {
        method: "GET",
        headers: {
            Authorization: token,
        },
    });

    return response.json().then(async (response) => {
        if (response.statusCode !== 200) {
            await refreshToken();
            return await getPersistedData(
                endpoint)
            //  throw Error(response.body.errorMessage)
        }
        return response;
    });
};

export async function addExpense(payload) {
    const token = await new Auth().getToken();
    const response = await fetch(`${apiurl}/dynamodb/expenses`, {
        method: "POST",
        headers: {
            Authorization: token,
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            payload: payload,
        }),
    });
    return response.json().then((response) => {
        if (response.body?.errorMessage) {
            throw Error(response.body.errorMessage);
        }
        return response;
    });
}

export const deleteExpense = async (attorney, date) => {
    const token = await new Auth().getToken();
    const response = await fetch(`${apiurl}/dynamodb/expenses?attorney=${attorney}&date=${date}`, {
        method: "DELETE",
        headers: {
            Authorization: token,
        },
    });
    return response.json().then((response) => {
        if (response.body?.errorMessage) {
            throw Error(response.body.errorMessage);
        }
        return response;
    });
};

export const getGroups = async () => {
    const url = `${apiurl}/dynamodb/groups`;
    const encoded = encodeURI(url);
    const token = await new Auth().getToken();
    const response = await fetch(encoded, {
        method: "GET",
        headers: {
            Authorization: token,
        },
    });


    return response.json().then(async (response) => {
        if (response.statusCode !== 200) {
            await refreshToken();
            return await getGroups()
            //  throw Error(response.body.errorMessage)
        }
        return response;
    });
};

export async function editGroup(payload) {
    const token = await new Auth().getToken();
    const response = await fetch(`${apiurl}/dynamodb/groups`, {
        method: "POST",
        headers: {
            Authorization: token,
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            payload: payload,
        }),
    });
    return response.json().then((response) => {
        if (response.body?.errorMessage) {
            throw Error(response.body.errorMessage);
        }
        return response;
    });
}

export const deleteGroup = async (id) => {
    const token = await new Auth().getToken();
    const response = await fetch(`${apiurl}/dynamodb/groups?id=${id}`, {
        method: "DELETE",
        headers: {
            Authorization: token,
        },
    });
    return response.json().then((response) => {
        if (response.body?.errorMessage) {
            throw Error(response.body.errorMessage);
        }
        return response;
    });
};
export const getCustoms = async () => {
    const url = "https://lvg24haprg.execute-api.us-east-1.amazonaws.com/prod/clio/data/customadj";
    const encoded = encodeURI(url);
    const token = await new Auth().getToken();

    try {
        const response = await fetch(encoded, {
            method: "GET",
            headers: {
                Authorization: token,
            },
        });

        const data = await response.json();


        // Parse matters and allocations for each item
        const parseItem = (item) => ({
            ...item,
            matters: typeof item.matters === "string" ? JSON.parse(item.matters) : item.matters,
            allocations: typeof item.allocations === "string" ? JSON.parse(item.allocations) : item.allocations,
        });

        return data.items.map(parseItem);

    } catch (err) {
        console.error("Error fetching customs:", err);
        throw err; // propagate error
    }
};

export async function uploadPersistedData(file) {
    try {
        // Convert file to base64
        const arrayBuffer = await file.arrayBuffer();
        const base64File = btoa(
            new Uint8Array(arrayBuffer)
                .reduce((data, byte) => data + String.fromCharCode(byte), "")
        );

        // Prepare JSON payload
        const payload = {
            fileName: file.name,
            fileType: file.type,
            fileData: base64File,
        };

        // Send to your Lambda API
        const response = await fetch(
            "https://lvg24haprg.execute-api.us-east-1.amazonaws.com/prod/clio/reports/upload-peristed-data",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            }
        );

        // Always read response as text
        const text = await response.text().catch(() => "");

        if (!response.ok) {
            console.error("Error response body:", text);
            throw new Error(text || `Upload failed: ${response.status}`);
        }

        // Try parsing JSON, fallback to raw text if invalid
        try {
            return JSON.parse(text);
        } catch {
            return text;
        }
    } catch (err) {
        console.error("Client-side error:", err);
        throw err;
    }
}
export async function uploadCustomAdjustments(file) {
    try {
        // Convert file to base64
        const arrayBuffer = await file.arrayBuffer();
        const base64File = btoa(
            new Uint8Array(arrayBuffer)
                .reduce((data, byte) => data + String.fromCharCode(byte), "")
        );

        // Prepare JSON payload
        const payload = {
            fileName: file.name,
            fileType: file.type,
            fileData: base64File,
        };

        // Send to your Lambda API
        const response = await fetch(
            "https://lvg24haprg.execute-api.us-east-1.amazonaws.com/prod/clio/reports/upload-custom-adj",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            }
        );

        // Always read response as text
        const text = await response.text().catch(() => "");

        if (!response.ok) {
            console.error("Error response body:", text);
            throw new Error(text || `Upload failed: ${response.status}`);
        }

        // Try parsing JSON, fallback to raw text if invalid
        try {
            return JSON.parse(text);
        } catch {
            return text;
        }
    } catch (err) {
        console.error("Client-side error:", err);
        throw err;
    }
}
export async function executeCustomAdjustmentsCalcul() {
    const token = await new Auth().getToken();
    const clio_token = clioTokenManager.getToken();
    const response = await fetch(`https://lvg24haprg.execute-api.us-east-1.amazonaws.com/prod/`, {
        method: "POST",
        headers: {
            Authorization: token,
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            clio_token: clio_token,
        }),
    });
    return response.json().then((response) => {
        if (response.body?.errorMessage) {
            throw Error(response.body.errorMessage);
        }
        return response;
    });
}
